import * as React from 'react'

const SvgMenuIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 14.8h16V16H2v-1.2zm0-3.6h16v1.2H2v-1.2zm0-3.6h16v1.2H2V7.6zM2 4h16v1.2H2V4z"
      fill="#163250"
    />
  </svg>
)

export default SvgMenuIcon
